import { Person, Logout, Shop, RoomService, DesignServices } from "@mui/icons-material";
import { Link } from "react-router-dom";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Avatar,
  Popover,
  List,
  ListItem,
  ListItemText,
  Divider
} from "@mui/material";
import { useState, MouseEvent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { WSIcons } from "../../commonFunctions/iIcons";
import { FaMapSigns, FaProductHunt } from "react-icons/fa";

interface NavigationItem {
  path: string;
  icon: React.ReactNode;
  label: string;
}

interface WSBottomNavProps {
  navigationItems: NavigationItem[];
}

const WSBottomNav: React.FC<WSBottomNavProps> = ({ navigationItems }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(location.pathname);

  const [notificationAnchor, setNotificationAnchor] =
    useState<null | HTMLElement>(null);
  const [profileAnchor, setProfileAnchor] = useState<null | HTMLElement>(null);
  const [masterAnchor, setMasterAnchor] = useState<null | HTMLElement>(null);

  const notifications = [
    { id: 1, text: "New order received" },
    { id: 2, text: "Your profile was updated" },
    { id: 3, text: "Server maintenance scheduled" }
  ];

  const handleProfileClick = (event: MouseEvent<HTMLElement>) =>
    setProfileAnchor(event.currentTarget);

  const handleMastersClick = (event: MouseEvent<HTMLElement>) =>
    setMasterAnchor(event.currentTarget);

  const handleClose = () => {
    setNotificationAnchor(null);
    setProfileAnchor(null);
    setMasterAnchor(null);
  };

  return (
    <Paper
      sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1400 }}
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          navigate(newValue);
          setValue(newValue);
        }}
        showLabels
      >
        {navigationItems.map(({ path, icon, label }) => (
          <BottomNavigationAction
            sx={{ color: "#4a4b77" }}
            key={path}
            label={label}
            icon={icon}
            value={path}
          />
        ))}

{/* Masters */}
<BottomNavigationAction
          sx={{ color: "#4a4b77" }}
          label="Masters"
          icon={<WSIcons.Masters sx={{ width: 24, height: 24 }} />}
          onClick={handleMastersClick}
        />

        {/* Profile */}
        <BottomNavigationAction
          sx={{ color: "#4a4b77" }}
          label="Profile"
          icon={<Avatar sx={{ width: 24, height: 24 }} />}
          onClick={handleProfileClick}
        />
      </BottomNavigation>

      {/* Notifications Popover */}
      <Popover
        open={Boolean(notificationAnchor)}
        anchorEl={notificationAnchor}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <List sx={{ width: 250 }}>
          {notifications.length > 0 ? (
            notifications.map((notification) => (
              <ListItem key={notification.id}>
                <ListItemText primary={notification.text} />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No notifications" />
            </ListItem>
          )}
        </List>
      </Popover>

{/* Masters Popover */}
      <Popover
        open={Boolean(masterAnchor)}
        anchorEl={masterAnchor}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <List sx={{ width: 150 }}>
          <ListItem component={Link} to="/user/registration">
            <Person sx={{ marginRight: 1 }} />
            <ListItemText primary="User" />
          </ListItem>
          <Divider />
          <ListItem component={Link} to="/franchise/list">
            <Shop sx={{ marginRight: 1 }} color="error"/>
            <ListItemText primary="Franchise" />
          </ListItem>
          
          <ListItem component={Link} to="/product/list">
            <FaProductHunt style={{marginRight:2}} />
            <ListItemText primary="Product" />
          </ListItem>

          <ListItem component={Link} to="/service/list">
            <RoomService sx={{ marginRight: 1 }} />
            <ListItemText primary="Service" />
          </ListItem>

          <ListItem component={Link} to="/add-on-service/list">
            <DesignServices sx={{ marginRight: 1 }} />
            <ListItemText primary="Add On Service" />
          </ListItem>

          <ListItem component={Link} to="/product-service-map/list">
            <FaMapSigns style={{marginRight:2}} />
            <ListItemText primary="Map Service" />
          </ListItem>
        </List>
      </Popover>

      {/* Profile Popover */}
      <Popover
        open={Boolean(profileAnchor)}
        anchorEl={profileAnchor}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <List sx={{ width: 150 }}>
          {/* <ListItem button onClick={() => navigate("/profile")}>
            <Person sx={{ marginRight: 1 }} />
            <ListItemText primary="Profile" />
          </ListItem> */}
          <Divider />
          <ListItem component={Link} to="/logOut">
            <Logout sx={{ marginRight: 1 }} color="error"/>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Popover>
      
    </Paper>
  );
};

export default WSBottomNav;
